import { skill } from "../profile/Profile";
import styles from './Skills.module.css';

export default function Skills() {
    return (
        <section className={styles.skillsSection}>
            <h2>ABILITÀ</h2>
            <div className={styles.skillsContainer}>
                {skill.map(element => (
                    <div className={styles.skillTag} key={element.title}>
                        <i className={element.icon} style={{ color: element.color, marginRight: '10px' }}></i>
                        {element.title}
                    </div>
                ))}
            </div>
        </section>
    );
}